function coveredTables(tableNumber, tableNumbers) {
  const list = Array.isArray(tableNumbers) ? [...tableNumbers] : [];
  list.push(tableNumber);
  return list.map(Number).filter((n) => Number.isFinite(n) && n > 0);
}

/** Whether a numbered table is one this phone films (main or extra table). */
export function phoneCoversTable(theirTable, { tableNumber, tableNumbers } = {}) {
  const theirs = Number(theirTable);
  if (!Number.isFinite(theirs) || theirs <= 0) return false;
  return coveredTables(tableNumber, tableNumbers).includes(theirs);
}

/**
 * Whether this phone should start or stop for a coach recording event.
 * A numbered table never wakes a phone that does not film that table,
 * even when both phones are signed in as the same user.
 * `tableNumbers` lists every table a wide-angle phone covers.
 */
export function phoneShouldRecordRemote(
  payload,
  { tableNumber, tableNumbers = null, userId } = {}
) {
  if (
    payload?.capture_all === true ||
    payload?.capture_all === 1 ||
    payload?.capture_all === "1" ||
    payload?.capture_all === "true"
  ) {
    const theirs = Number(payload?.table_number);
    if (Number.isFinite(theirs) && theirs > 0) {
      return phoneCoversTable(theirs, { tableNumber, tableNumbers });
    }
    return true;
  }

  const theirs = Number(payload?.table_number);
  if (Number.isFinite(theirs) && theirs > 0) {
    return phoneCoversTable(theirs, { tableNumber, tableNumbers });
  }

  const targetUser =
    payload?.receiver_user_id != null ? String(payload.receiver_user_id) : "";
  const me = userId != null ? String(userId) : "";
  return Boolean(targetUser && me && targetUser === me);
}
